import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { getallbookings } from '../redux/actions/bookingActions';
import {deleteUser, getAllUsers} from '../redux/actions/userActions2';
import { DeleteOutlined } from '@ant-design/icons';
import moment from 'moment';



export default function Customers() {
    const dispatch = useDispatch();
    // const[users , setusers] = useState()
    const usersstate = useSelector( state => state.users);
    const {users} = usersstate;

    useEffect(() => {

        dispatch(getAllUsers());
        
    }, []);

    return (
        <div>

            <h4> Total Users - {users.length}</h4>
            <table className='table table-striped table-bordered table-responsive-sm'>
                <thead className='thead-dark'>
                    <tr>
                        <th>User Id</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>createdOn</th>
                        <th>isAdmin</th>
                        <th>Delete</th>
                    </tr>
                </thead>

                <tbody>
                    {users && users.map(user => {
                        return <tr key={user._id}>
                            <td>{user._id}</td>
                            <td>{user.name}</td>
                            <td>{user.email}</td>
                            <td>{moment(user.createdAt).format('DD MMM yyyy HH:MM')}</td>
                            <td>{user.isAdmin ? 'YES' : 'NO'}</td>
                            <td>
                                <DeleteOutlined 
                                    className='fa fa-trash' 
                                    style={{ color: 'red', cursor: 'pointer'}}
                                    onClick={()=>{dispatch(deleteUser(user._id));}} />
                            </td>
                        </tr>;
                    })}
                </tbody>

            </table>

        </div>
    );
}
